import { Children } from "react";
import { Field, FormikProps } from "formik";
import styles from "../../lessonsForm.module.css";
import { useSubject } from "../../../../../hooks/useSubject";
import { GetSubjects_getSubjects } from "../../../../../__generated__/gql-types/GetSubjects";

const SUBJECT_TTITLE = "Asignatura";
const SUBJECT_PLACEHOLDER = "Seleccionar";

interface ISubjectInputProps {
  errors: FormikProps<any>["errors"];
  touched: FormikProps<any>["touched"];
  values: FormikProps<any>["values"];
}

export function SubjectInput({ errors, touched, values }: ISubjectInputProps) {
  const { subjects } = useSubject();

  const sortSubjects = [...subjects].sort(
    (a, b) => Number(a.id) - Number(b.id)
  );

  const fieldClassName =
    errors.grade_id && touched.grade_id
      ? styles.formFieldsError
      : styles.formFieldSelect;

  return (
    <>
      <label htmlFor="course">{SUBJECT_TTITLE}</label>
      <Field
        as="select"
        id="subject_id"
        name="subject_id"
        value={values.subject_id}
        className={fieldClassName}
      >
        <option disabled value="">
          {SUBJECT_PLACEHOLDER}
        </option>
        {Children?.toArray(
          sortSubjects?.map((subject) => (
            <option value={subject?.id}>{subject?.name}</option>
          ))
        )}
      </Field>
    </>
  );
}
